import { render, staticRenderFns } from "./TranslatorSelect.vue?vue&type=template&id=5488a876&scoped=true&"
import script from "./TranslatorSelect.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TranslatorSelect.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TranslatorSelect.vue?vue&type=style&index=0&id=5488a876&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5488a876",
  null
  
)

export default component.exports